import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LetterIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 54,
  height = 54,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M51 24.7v25c0 1.3-1 2.3-2.4 2.3H6.4C5 52 4 51 4 49.8V24.7"
          stroke="#000000"
          className={styles.defaultStrokeColour}
          strokeWidth="2"
        />
        <g transform="translate(3 9)">
          <path
            d="M25.2.2c-.6 0-1.1.1-1.6.4l-22 12.1a3 3 0 00-.1 5.4l20.1 12.1a6.1 6.1 0 006.4 0L47.5 18a3 3 0 000-5.2L26.8.6c-.5-.3-1-.4-1.6-.4m0 2l.6.1 20.7 12.2a1 1 0 010 1.8L27 28.5a4.1 4.1 0 01-4.3 0L2.5 16.4a1 1 0 010-2l22.1-12c.2-.2.4-.2.6-.2"
            fill="#00000"
            className={styles.defaultColor}
          />
        </g>
        <path
          d="M44 26.4l-14.3 8.4c-1.5.9-3.4.9-4.9 0L11 26c-.6-.3-.9-.9-.9-1.5V3.9c0-1 1-1.9 2.1-1.9H43c1.2 0 2.2.9 2.2 2v20.8c0 .6-.4 1.2-1 1.6"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M17.4 8.5h10.1m-10.1 4.7H38m-20.6 5.3h20.3m-20.3 5h20.3"
          stroke="#ffffff"
          className={styles.whiteStroke}
          strokeLinecap="round"
        />
      </g>
    </Icon>
  )
}
